import React from 'react';

import Quicks from '../components/quicks';
import MarkdownSection from '../components/markdown-section';
import NewsUpdates from '../components/news-updates';
import Projects from '../components/projects';
import Contact from '../components/contact';

const Component = () => {
    return (
        <div>
            <Quicks
                links={[
                    { name: 'People', link: 'people' },
                    { name: 'Publications', link: 'publications' },
                    { name: 'Tools & Data', link: 'tools-data' },
                    { name: 'Photo Gallery', link: 'gallery' }
                ]}
                navs={[
                    { name: 'Projects', link: '#Projects' },
                    { name: 'Contact', link: '#Contact' }
                ]}
            />

            <div className="row">
                <div className="col-md-8">
                    <MarkdownSection
                        className="row"
                        header="About"
                        sectionID="About"
                        mdURL="_data/home/about.md"
                    />
                </div>
                <div className="col-md-4">
                    <NewsUpdates news={[]} />
                </div>
                <Projects />
                <Contact />
            </div>
        </div>
    );
};

export default Component;
